<template>
    <router-link
        :to="to"
        class="flex h-full flex-col gap-3 rounded-xl border-2 border-taupe-200 bg-white p-4 transition-all hover:border-sky-400 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-sky-500"
    >
        <div
            class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sky-700 [&_svg]:size-6"
        >
            <slot name="icon" />
        </div>
        <div class="space-y-1 leading-5">
            <h3 class="font-medium text-taupe-800">{{ title }}</h3>
            <div class="text-sm text-taupe-600">
                <slot />
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'ReportCard',
    props: {
        to: {
            type: [String, Object],
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
}
</script>
